import Panel from "./Panel.js"

export default class PlaybackRate extends Panel {

  constructor(props, context) {
    super(props, context)
    this.state.title = "Speed" // TODO: This needs to be localized
    this.listOptions = [
      { label: "0.25", value: 0.25 },
      { label: "0.5", value: 0.5 },
      { label: "Normal", value: 1 },
      { label: "1.25", value: 1.25 },
      { label: "1.5", value: 1.5 },
      { label: "2", value: 2 }
    ]

    this.state.activeIndex = 2
    this.listOptions.forEach((option, index) => {
      if (option.value == this.player.playbackRate) {
        this.state.activeIndex = index
      }
    })
    this.classList.add("amp-playback-rate")
  }

  static get contextTypes() {
    return super.contextTypes
  }

  clickHandler(object, index) {
    this.player.playbackRate = object.value
    super.clickHandler(object, index)
  }

  isOptionSelected(item, index) {
    return (parseFloat(item.value) === parseFloat(this.player.playbackRate))
  }
}
